import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: BASE, timeout: 12000, withCredentials: true });

// Catalog getters (caller should provide mock fallback)
export const getProducts = (params = {}) => client.get("/products", { params }).then((r) => r.data);
export const getGrapes = () => client.get("/grape-varieties").then((r) => r.data);
export const getProducers = () => client.get("/producers").then((r) => r.data);
export const getRegions = () => client.get("/regions").then((r) => r.data);
export const getBlog = () => client.get("/blog").then((r) => r.data);
export const getBlogPost = (slug) => client.get(`/blog/${slug}`).then((r) => r.data);
export const getProduct = (id) => client.get(`/products/${id}`).then((r) => r.data);

// Transactional
export const createCuvee = (payload) => client.post("/cuvees", payload).then((r) => r.data);
export const getCuvee = (id) => client.get(`/cuvees/${id}`).then((r) => r.data);
export const createOrder = (payload) => client.post("/orders", payload).then((r) => r.data);
export const sendContact = (payload) => client.post("/contact", payload).then((r) => r.data);
export const subscribeNewsletter = (email) => client.post("/newsletter", { email }).then((r) => r.data);

// Auth
export const authRegister = (payload) => client.post("/auth/register", payload).then((r) => r.data);
export const authLogin = (payload) => client.post("/auth/login", payload).then((r) => r.data);
export const authLogout = () => client.post("/auth/logout").then((r) => r.data);
export const authMe = () => client.get("/auth/me").then((r) => r.data);
export const forgotPassword = (email) => client.post("/auth/forgot-password", { email, origin_url: window.location.origin }).then((r) => r.data);
export const resetPassword = (token, password) => client.post("/auth/reset-password", { token, password }).then((r) => r.data);
export const getMyOrders = () => client.get("/my/orders").then((r) => r.data);

// Checkout
export const createCheckoutSession = (payload) => client.post("/checkout/session", payload).then((r) => r.data);
export const getCheckoutStatus = (sessionId) => client.get(`/checkout/status/${sessionId}`).then((r) => r.data);
export const validateDiscount = (code, subtotal) => client.post("/discount/validate", { code, subtotal }).then((r) => r.data);

// Admin
export const adminStats = () => client.get("/admin/stats").then((r) => r.data);
export const adminOrders = (status) => client.get("/admin/orders", { params: status ? { status } : {} }).then((r) => r.data);
export const adminUpdateOrder = (id, status) => client.patch(`/admin/orders/${id}`, { status }).then((r) => r.data);
export const adminDiscounts = () => client.get("/admin/discounts").then((r) => r.data);
export const adminCreateDiscount = (payload) => client.post("/admin/discounts", payload).then((r) => r.data);
export const adminToggleDiscount = (code) => client.patch(`/admin/discounts/${code}`).then((r) => r.data);
export const adminDeleteDiscount = (code) => client.delete(`/admin/discounts/${code}`).then((r) => r.data);
export const adminContacts = () => client.get("/admin/contacts").then((r) => r.data);
export const adminSyncWp = () => client.post("/admin/sync-wp").then((r) => r.data);
export const getStoreSettings = () => client.get("/settings/store").then((r) => r.data);
export const updateStoreSettings = (soldOut) => client.patch("/admin/settings/store", { sold_out: soldOut }).then((r) => r.data);
export const joinWaitlist = (payload) => client.post("/restock-waitlist", payload).then((r) => r.data);
export const adminWaitlist = () => client.get("/admin/waitlist").then((r) => r.data);
export const notifyWaitlist = () => client.post("/admin/waitlist/notify-all").then((r) => r.data);
export const aiVisibilityQuestions = () => client.get("/admin/ai-visibility/questions").then((r) => r.data);
export const aiVisibilityRun = () => client.post("/admin/ai-visibility/run", {}, { timeout: 180000 }).then((r) => r.data);
export const aiVisibilityRuns = () => client.get("/admin/ai-visibility/runs").then((r) => r.data);

export default client;
